// Gateway-specific configuration fields
export const GATEWAY_CONFIG_FIELDS = {
  STRIPE: [
    {
      key: "publishableKey",
      label: "Publishable Key",
      type: "text",
      required: true,
    },
    { key: "secretKey", label: "Secret Key", type: "password", required: true },
    {
      key: "webhookSecret",
      label: "Webhook Secret",
      type: "password",
      required: false,
    },
    {
      key: "apiVersion",
      label: "API Version",
      type: "text",
      required: false,
      defaultValue: "2023-10-16",
    },
  ],
  PAYPAL: [
    { key: "clientId", label: "Client ID", type: "text", required: true },
    {
      key: "clientSecret",
      label: "Client Secret",
      type: "password",
      required: true,
    },
    {
      key: "environment",
      label: "Environment",
      type: "select",
      required: true,
      options: ["sandbox", "production"],
    },
    { key: "webhookId", label: "Webhook ID", type: "text", required: false },
  ],
  HYPERPAY: [
    { key: "entityId", label: "Entity ID", type: "text", required: true },
    {
      key: "accessToken",
      label: "Access Token",
      type: "password",
      required: true,
    },
    {
      key: "entityIdSandbox",
      label: "Entity ID Sandbox",
      type: "text",
      required: false,
    },
    {
      key: "accessTokenSandbox",
      label: "Access Token Sandbox",
      type: "password",
      required: false,
    },
  ],
  EFAWATEERCOM: [
    {
      key: "serviceType",
      label: "Service Type",
      type: "text",
      required: true,
    },
    {
      key: "receiverCode",
      label: "Receiver Code",
      type: "text",
      required: true,
    },
  ],
  CLIQ: [
    {
      key: "alias",
      label: "Cliq Alias (Name / Phone Number)",
      type: "text",
      required: true,
    },
    {
      key: "accountHolderName",
      label: "Account Name",
      type: "text",
      required: true,
    },
    {
      key: "instructions",
      label: "Description",
      type: "textarea",
      required: false,
    },
  ],
  CASH: [
    {
      key: "instructions",
      label: "Payment Instructions",
      type: "textarea",
      required: false,
    },
    {
      key: "contactInfo",
      label: "Contact Information",
      type: "text",
      required: false,
    },
  ],
  WIRE_TRANSFER: [
    { key: "bankName", label: "Bank Name", type: "text", required: true },
    {
      key: "accountNumber",
      label: "Account Number",
      type: "text",
      required: true,
    },
    {
      key: "routingNumber",
      label: "Routing Number",
      type: "text",
      required: true,
    },
    { key: "swiftCode", label: "SWIFT Code", type: "text", required: false },
    {
      key: "beneficiaryName",
      label: "Beneficiary Name",
      type: "text",
      required: true,
    },
    {
      key: "beneficiaryAddress",
      label: "Beneficiary Address",
      type: "textarea",
      required: false,
    },
  ],
};

export const EFAWATEERCOM_CONVENTION = {
  SAJILNI: {
    RECEIVER_CODE: 662,
    SERVICE_TYPE: "sajilni_pay_ticket",
  },
  JFA: {
    RECEIVER_CODE: 451,
    SERVICE_TYPE: "jfa_pay_ticket",
  },
} as const;
